import React from 'react';

import { Link } from 'gatsby';

import { useTheme } from '@mui/material';

import { ProductCardKeyFacts } from '@mewa/ui';

import { ProductFallbackImage } from '../product-fallback-image';
import { ProductCardBaseData } from './product-card-base';
import { getImages, ProductImage } from './product-card-helper';

type Props<T extends ProductCardBaseData> = {
  useMbsFallbackIcon: boolean;
  product: T;
  style?: React.CSSProperties;
  className?: string;
  langPrefix: string;
  detailsPageLabel: string;
};

export const ProductCardKeyFactsWrapper = React.memo(
  <T extends ProductCardBaseData>({
    useMbsFallbackIcon,
    product: { displayName, modelName, collection, keyFacts, variants },
    style,
    className,
    langPrefix,
    detailsPageLabel,
  }: Props<T>) => {
    const theme = useTheme();

    const image = variants[0].assetId ? (
      <ProductImage
        images={getImages(variants[0].assetId, theme)}
        alt={displayName}
      />
    ) : (
      <ProductFallbackImage useMbsFallbackIcon={useMbsFallbackIcon} />
    );

    return (
      <ProductCardKeyFacts
        className={className}
        style={style}
        title={collection?.name ? displayName : modelName}
        keyFacts={keyFacts}
        productLink={{
          label: detailsPageLabel,
          LinkComponent: Link,
          url: `${langPrefix}/${variants[0].slug}`,
        }}
        image={image}
      />
    );
  },
);

ProductCardKeyFactsWrapper.displayName = 'SwiperSlide';
